module.exports = __webpack_public_path__ + "img/21.bb7fd852.jpg";